import { PackageLiabilityPanel } from '../packages/index.js';
import { useAuth } from '../../lib/auth.js';
import { CommissionRatesPanel } from './CommissionRatesPanel.js';
import { DiscountsReportPanel } from './DiscountsReportPanel.js';
import { PromoCodesPanel } from './PromoCodesPanel.js';
import { VouchersAdminPanel } from './VouchersAdminPanel.js';

/**
 * WS9 — the "Money admin" tab: the salon's money-control panels, each gated on isFloorManager (mirror of
 * ChairRentPanel) so a non-manager gets an honest note and no admin read/mutation ever fires a guaranteed
 * 403.
 *
 *  - CommissionRatesPanel — per-staff commission rules (default % + per-category overrides; bps shown as %).
 *  - VouchersAdminPanel   — issued list + the SERVER's liability reconciliation (revenueRecognisedPence, the
 *                           `reconciles` invariant), per-row Void, and the breakage sweep.
 *  - PromoCodesPanel      — online-booking promo codes (value + scope immutable after create).
 *  - DiscountsReportPanel — where margin is going, by reason code, + the recent-discount audit.
 *
 * MONEY HONESTY (ADR-0009): every money figure here is the server's — voucher SALES are a liability, never
 * revenue; the only "revenue" shown is the liability report's recognised figure. Nothing is recomputed in JS.
 */
export function MoneyAdminTab() {
  const { isFloorManager } = useAuth();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <CommissionRatesPanel isFloorManager={isFloorManager} />
      <VouchersAdminPanel isFloorManager={isFloorManager} />
      {/* WS-13 — outstanding prepaid-package liability (manager-only read; gated so it never fires for
          a non-manager). A sold package is a liability, never revenue. */}
      {isFloorManager ? <PackageLiabilityPanel enabled={isFloorManager} /> : null}
      <PromoCodesPanel isFloorManager={isFloorManager} />
      <DiscountsReportPanel isFloorManager={isFloorManager} />
    </div>
  );
}
